import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function grupoTratamentoUFClassificacaoReducer(state = initialState.grupoTratamentoUFClassificacao, action){
    switch(action.type) {
        case types.OBTER_GRUPOTRATAMENTO_UF_CLASSIFICACOES:
            
            return action.grupoTratamentoUFClassificacao;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/grupoTratamentoReducerUFClassificacaoReducer.js
 **/